import { Component } from '@angular/core';
import { AuthService } from 'src/app/@core/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-claims-modal',
    templateUrl: './claims-modal.component.html',
    styleUrls: ['./claims-modal.component.scss'],
    standalone: false
})
export class ClaimsModalComponent {
  public production: boolean = false;
  public credentials: any;

  constructor(private authService: AuthService) {
    this.production = environment.production;
    this.credentials = authService.getClaims();
  }
}
